module.exports = __webpack_public_path__ + "img/1415528913.ddb80e36.jpg";